export function spacing(multiplier: number): string {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return `${5 * multiplier}px`
}
